import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import {
  reservationCreateShape,
  reservationShape,
  reservationGuestFromFormShape,
  reservationFiltersShape,
  quickAddGuestShape,
} from './models'
import { z } from 'zod'
import { reservationGuestShape } from '../reservation-guests/models'
const customCreateGuest = createCustomServiceCall({
  inputShape: reservationGuestFromFormShape,
  outputShape: reservationShape,
  cb: async ({ client, input, utils }) => {
    const { reservation_id, ...rest } = utils.toApi(input)
    const res = await client.post(`/stays/reservations/${reservation_id}/guests/`, rest)
    return utils.fromApi(res.data)
  },
})
const quickAddGuest = createCustomServiceCall({
  inputShape: quickAddGuestShape,
  outputShape: reservationGuestShape,
  cb: async ({ client, input, utils }) => {
    const { reservation_id, ...rest } = utils.toApi(input)
    const res = await client.post(`/stays/reservations/${reservation_id}/guests/`, rest)
    return utils.fromApi(res.data)
  },
})
const customUpdateGuest = createCustomServiceCall({
  inputShape: { ...reservationGuestFromFormShape, guestId: z.string() },
  outputShape: reservationShape,
  cb: async ({ client, input, utils }) => {
    const { reservation_id, ...rest } = utils.toApi(input)
    const res = await client.patch(`/stays/reservations/${reservation_id}/guests-update/`, rest)
    return utils.fromApi(res.data)
  },
})

const purgeGuestData = createCustomServiceCall({
  inputShape: z.string().uuid(),
  outputShape: {
    status: z.enum(['success', 'partial']),
    scrubbedCount: z.number(),
    failedCount: z.number(),
  },
  cb: async ({ client, slashEndingBaseUri, input, utils: { fromApi } }) => {
    const res = await client.post(`${slashEndingBaseUri}${input}/purge-guest-data/`)
    return fromApi(res.data)
  },
})

export const reservationApi = createApi({
  baseUri: '/stays/reservations/',
  client: axiosInstance,
  models: {
    entity: reservationShape,
    create: reservationCreateShape,
    extraFilters: reservationFiltersShape,
  },
  customCalls: {
    createGuest: customCreateGuest,
    quickAddGuest,
    updateGuest: customUpdateGuest,
    purgeGuestData,
  },
})
